module.exports = __webpack_public_path__ + "img/kosal.3ce1858f.png";